import { Component, Input, OnInit } from '@angular/core';
import { ActionService } from 'src/app/core/services/action.service';
import { TaskRequestSidenavService } from 'src/app/core/services/task-request-sidenav.service';
import { ErrorsEnum, ErrorService } from 'src/app/core/services/error.service';

@Component({
  selector: 'app-picking-inventory-sidenav',
  templateUrl: './picking-inventory-sidenav.component.html',
  styleUrls: ['./picking-inventory-sidenav.component.scss']
})
export class PickingInventorySidenavComponent implements OnInit {
  @Input() drawer;
  @Input() data;
  usersHighlighted = [];
  selectOperatorError = false;

  constructor(
    private sidenavService: TaskRequestSidenavService,
    private actionService: ActionService,
    private errorService: ErrorService,
  ) { }


  ngOnInit(): void {
  }

  setUsers(users) {
    this.usersHighlighted = users;
  }

  setOperatorLengthError() {
    this.selectOperatorError = !this.usersHighlighted.length;
  }

  async submit() {
    try {
      this.setOperatorLengthError();
      if (this.usersHighlighted.length) {
        const params = {
          outOrderId: this.data.id,
          userIds: this.usersHighlighted,
        }
        await this.actionService.startOutOrderValidation(params);
      }
      this.drawer.close();
      this.sidenavService.closeSidenav(true);
      this.usersHighlighted = [];
    } catch (e) {
      switch (e?.error?.type) {
        case ErrorsEnum.USER_ERROR_NOT_FOUND:
        case ErrorsEnum.OUT_ORDER_STATE_CONFLICT:
        case ErrorsEnum.OUT_ORDER_WITHOUT_CRATES:
        case ErrorsEnum.OUT_ORDER_CRATE_STATE_CONFLICT:
        case ErrorsEnum.OUT_ORDER_TASK_EXIST:
          this.errorService.openErrorSnackBar(e);
          break;
        default:
          this.errorService.openErrorSnackBar(e);
      }
    }
  }

  close() {
    try {
      this.drawer.close();
      this.sidenavService.closeSidenav(false);
    } finally {
      this.usersHighlighted = [];
    }
  }


}
